const getIsPc = () => {
  const userAgentInfo = navigator.userAgent;
  const Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

// window.addEventListener("load", () => {
//   new BlockMoveUtil({
//     getContainer: () => window.document.getElementById("launcher"),
//     getTarget: (container) =>
//       container?.contentDocument?.documentElement?.getElementsByTagName(
//         "button"
//       )[0],
//   });
// });

class BlockMoveUtil {
  initCheckCount = 6;
  initCheckInterval = 1000;
  container = window.document.documentElement;
  target = null;
  options = {};
  startX = null;
  startY = null;
  touchStartTime = null;
  isMobile = !getIsPc();

  constructor(options) {
    const { getContainer, getTarget } = options;
    this.options = { ...options };
    if (typeof getContainer === "function") {
      this.container = getContainer();
    }
    if (typeof getTarget === "function") {
      this.target = getTarget(this.container);
    }
    this.checkTargetInited();
  }

  checkTargetInited = () => {
    console.log(this.target, this, "====>checkTargetInited");
    if (this.target) {
      this.init();
    } else {
      if (this.initCheckCount === 0) return;
      setTimeout(() => {
        this.initCheckCount--;
        if (
          !this.container &&
          typeof this.options.getContainer === "function"
        ) {
          this.container = this.options.getContainer();
        }
        if (typeof this.options.getTarget === "function") {
          this.target = this.options.getTarget(this.container);
          this.checkTargetInited();
        }
      }, this.initCheckInterval);
    }
  };

  handleTouchStart = (e) => {
    console.log(e, window, "=====>handleTouchStart");
    e.stopPropagation();
    this.startX = e.pageX;
    this.startY = e.pageY;
    this.touchStartTime = Date.now();
    window.document.body.addEventListener(
      this.isMobile ? "touchmove" : "mousemove",
      this.handleTouchMove
      // true
    );
    window.document.body.addEventListener(
      this.isMobile ? "touchend" : "mouseup",
      this.handleTouchEnd
      // true
    );
  };

  handleTouchEnd = (e) => {
    e.preventDefault();
    console.log(e, "=====>handleTouchEnd");
    if (this.touchStartTime && Date.now() - this.touchStartTime <= 500) {
      this.target.click();
    }
    this.startX = null;
    this.startY = null;
    this.touchStartTime = null;
    window.document.body.removeEventListener(
      this.isMobile ? "touchmove" : "mousemove",
      this.handleTouchMove
      // true
    );
    window.document.body.removeEventListener(
      this.isMobile ? "touchend" : "mouseup",
      this.handleTouchEnd
      // true
    );
  };

  handleTouchMove = (e) => {
    e.preventDefault();
    console.log(e, [this.container], "=====>handleTouchMove");
    const newX = e.pageX,
      newY = e.pageY;
    const diffX = newX - this.pageX,
      diffY = newY - this.pageY;
    this.container.style.left =
      (parseFloat(this.container.offsetLeft) || 0) + diffX + "px";
    this.container.style.top =
      (parseFloat(this.container.offsetTop) || 0) + diffY + "px";
    this.pageX = newX;
    this.pageY = newY;
    console.log(this.container.style.left, "=====>handleTouchMove after");
  };

  init = () => {
    // console.log(this.isMobile, this, "======>init");
    // this.container.parentElement.style.position = "fixed";
    // this.container.parentElement.style.zIndex = 1000000;
    // this.container.parentElement.style.left = this.container.offsetLeft + "px";
    // this.container.parentElement.style.top = this.container.offsetTop + "px";
    // this.container.parentElement.style.width = this.container.style.width;
    // this.container.parentElement.style.height = this.container.style.height;
    const container = this.container.contentDocument ?? this.container;
    // window.document.body.addEventListener(
    //   this.isMobile ? "touchmove" : "mousemove",
    //   console.log
    //   // true
    // );
    // console.log(this.isMobile, this, container, "======>init");
    // if (!this.isMobile) {
    //   container.addEventListener("touchstart", this.handleTouchStart, true);
    //   container.addEventListener("touchmove", this.handleTouchMove, true);
    //   container.addEventListener("touchend", this.handleTouchEnd, true);
    // } else {
    //   container.addEventListener("mousedown", this.handleTouchStart, true);
    //   container.addEventListener("mousemove", this.handleTouchMove, true);
    //   container.addEventListener("mouseup", this.handleTouchEnd, true);
    // }

    // this.target.addEventListener(
    //   "click",
    //   () => {
    //     console.log("=====>tareget click", this.target);
    //   },
    //   true
    // );
  };
}
